import {
  FileUploadService,
  FileValidationService,
} from '@shared/components/file-upload';
import { ActivateComponentService } from './activate-component.service';
import { AfterOfflineSyncService } from './after-offline-sync.service';
import { CacheService } from './cache.service';
import { CryptoService } from './crypto.service';
import { CurrentUserDataService } from './current-user-data.service';
import { DataRefreshService } from './data-refresh.service';
import {
  DprAttachmentService,
  DprDetailsWarningService,
  NamingConventionService,
} from './dpr';
import { FileSaverService, FileService } from './files';
import { SyncService } from './grid';
import { MergeService } from './merge.service';
import { ModuleNavigationService } from './module-navigation.service';
import { NavigationService } from './navigation.service';
import { NotificationService } from './notification.service';
import { OfflineSyncService } from './offline-sync.service';
import { OfflineSyncSanitizeService } from './offline-sync-sanitize.service';
import { OrderingService } from './ordering.service';
import {
  BasePersistenceService,
  LocalPersistenceService,
  PersistenceService,
  RemotePersistenceService,
} from './persistence';
import { RoutingService } from './routing.service';
import { SelectedAccountService } from './selected-account.service';
import { ServiceWorkerUpdateService } from './service-worker-update.service';
import { SignOutService } from './sign-out.service';
import { SignalRService } from './signalr.service';
import { SubprojectService } from './subproject.service';
import { ToastNotificationService } from './toast-notification.service';
import { UnsavedChangesService } from './unsaved-changes.service';
import { UserRightsService } from './user-rights.service';
import { UserSessionChangeService } from './user-session-change.service';
import { ClientSupportService } from './client-support.service';
import { GenericHttpClientService } from './generic-http-client.service';
import { ScreenSizeService } from './screen-size.service';
import { ZendeskService } from './zendesk.service';

export {
  ActivateComponentService,
  AfterOfflineSyncService,
  CacheService,
  CryptoService,
  CurrentUserDataService,
  DataRefreshService,
  MergeService,
  ModuleNavigationService,
  NavigationService,
  NotificationService,
  OfflineSyncService,
  OfflineSyncSanitizeService,
  OrderingService,
  RoutingService,
  SelectedAccountService,
  ServiceWorkerUpdateService,
  SignOutService,
  SignalRService,
  SubprojectService,
  ToastNotificationService,
  UnsavedChangesService,
  UserRightsService,
  UserSessionChangeService,
  DprAttachmentService,
  ClientSupportService,
  GenericHttpClientService,
  ScreenSizeService,
  ZendeskService,
};

export const services = [
  ActivateComponentService,
  AfterOfflineSyncService,
  CacheService,
  CryptoService,
  CurrentUserDataService,
  DataRefreshService,
  MergeService,
  ModuleNavigationService,
  NavigationService,
  NotificationService,
  OfflineSyncService,
  OfflineSyncSanitizeService,
  OrderingService,
  RoutingService,
  SelectedAccountService,
  ServiceWorkerUpdateService,
  SignOutService,
  SignalRService,
  SubprojectService,
  ToastNotificationService,
  UnsavedChangesService,
  UserRightsService,
  DprDetailsWarningService,
  NamingConventionService,
  FileSaverService,
  FileService,
  SyncService,
  BasePersistenceService,
  LocalPersistenceService,
  PersistenceService,
  RemotePersistenceService,
  FileUploadService,
  FileValidationService,
  UserSessionChangeService,
  DprAttachmentService,
  ClientSupportService,
  GenericHttpClientService,
  ScreenSizeService,
  ZendeskService,
];
